import { isDefaultBrand, useConfig } from '@travelwin/core';
import { useTranslation } from 'react-i18next';

import { NavItem } from '../interfaces/NavBar';
import { isRemix } from '../utils/ssrUtils';
import { getPathnameWithLocale } from '../utils/urlUtils';
import { useExternalHomepageConfig } from './useExternalHomepageConfig';
import { useLocaleUtils } from './useLocaleUtils';

export const useStoreLocatorItem = () => {
  const { WHITELABEL_BRAND } = useConfig();
  const { t } = useTranslation();
  const { getHomepageUrl } = useExternalHomepageConfig();
  const { currentLocale } = useLocaleUtils();

  const storeLocator: NavItem = {
    id: '3',
    label: t('navbar.store_locator', 'Store Locator'),
    to: isRemix()
      ? getPathnameWithLocale('/store-locations', currentLocale)
      : getHomepageUrl('/store-locations'),
    ecommerceRoute: false,
    visible: isDefaultBrand(WHITELABEL_BRAND),
    'data-testid': 'link-store-locator',
    icon: 'storeFront',
  };

  return storeLocator;
};
